// extracted by mini-css-extract-plugin
module.exports = {"dateGroup":"OfferList_dateGroup__3UT_C","date":"OfferList_date__1X5Jj"};